import { render, staticRenderFns } from "./GlobalYousignIFrame.vue?vue&type=template&id=40984414&scoped=true"
import script from "./GlobalYousignIFrame.vue?vue&type=script&lang=js"
export * from "./GlobalYousignIFrame.vue?vue&type=script&lang=js"
import style0 from "./GlobalYousignIFrame.vue?vue&type=style&index=0&id=40984414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40984414",
  null
  
)

export default component.exports